import script from "./iconModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./iconModal.vue?vue&type=script&setup=true&lang=ts"

import "./iconModal.vue?vue&type=style&index=0&id=ba8516a4&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba8516a4"]])

export default __exports__